import {GridCellProps } from "@progress/kendo-react-grid"
import React from "react"
import { useNavigate } from "react-router"
import { useAppDispatch } from "../../../../app/hooks";
import { GridButton } from "../../../../components";
import { verifyApi } from "../../../../services/verifyService/verify-api";

function VerificationViewCell(props:GridCellProps){
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    
    // Don't render button in group header rows
    if (props.dataItem.aggregates || props.dataItem.items) {
        return null;
    }
    
    return <React.Fragment>
        <GridButton variant={"outlined"} size='small' 
            color={props.dataItem.assistanceNeeded? 'error' : 'primary'}
            onClick={()=>{navigate('/Verification/'+props.dataItem.id); dispatch(verifyApi.util.invalidateTags(['verification']));}}>View</GridButton>
    </React.Fragment>
}

export{VerificationViewCell}